import { types } from './types';
import { instance, instanceWithoutCreds } from 'store/utils';
import { clearForm } from 'store/forms/actions';
import { clearApptrack } from 'store/appTrack/actions';
import { triggerLoading } from 'store/forms/actions';
import { message } from 'antd';
import { Errors } from 'utils/errors';

const loginEndpoint = '/app/authentication';
const getOAuth2ClientsEndpoint = '/app/oauth2-clients';
const loginCheckerEndpoint = '/app/rest/account-checker';
const askTempPasswordEndpoint = '/app/temp-password';
const setNewPasswordEndpoint = '/app/rest/new-password';

export const confirmLogin = (payload, navigate, callback) => dispatch => {
  dispatch({ type: types.GET_USER_DATA.START });
  dispatch(triggerLoading(true));
  instance
    .post(`/app/authentication`, payload)
    .then(response => {
      const payloadR = {
        j_username: payload.j_username,
        _spring_security_remember_me: payload._spring_security_remember_me,
        submit: payload.submit,
        status: response.status,
        date: response.headers.date,
      };

      dispatch({
        type: types.GET_USER_DATA.SUCCESS,
        payload: payloadR,
      });

      dispatch(triggerLoading(false));
      navigate('/fundingpage');
      callback(false);
    })
    .catch(error => {
      console.log('error login:', error);
      dispatch(triggerLoading(false));
      dispatch({
        type: types.GET_USER_DATA.ERROR,
      });
      callback(true);
    });
};

export const getTaxisData = taskId => dispatch => {
  dispatch({ type: types.GET_TAXIS_DATA.START });
  instance
    .get('/app/rest/taxis-details')
    .then(response => {
      dispatch({
        type: types.GET_TAXIS_DATA.SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      dispatch({ type: types.GET_TAXIS_DATA.ERROR });
    });
};

export const getTaxisDataByTk = tk => dispatch => {
  dispatch({ type: types.GET_TAXIS_DATA_BY_TK.START });
  instance
    .get(`/app/rest/account/findInfoByZip/${tk}`)
    .then(response => {
      console.log(response.data);
      dispatch({
        type: types.GET_TAXIS_DATA_BY_TK.SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      dispatch({ type: types.GET_TAXIS_DATA_BY_TK.ERROR });
    });
};

export const updateUserNp = payload => dispatch => {
  dispatch({ type: types.UPDATE_USER_NP, payload });
};

// export const login = (username, password) => async (dispatch) => {
//   dispatch({ type: types.LOGIN.START });
//   try {
//     const response = await instance.post(loginEndpoint, { username, password });
//     console.log('Login response:', response.data);
//     dispatch({ type: types.LOGIN.SUCCESS, payload: response.data });
//   } catch (error) {
//     console.error('Login failed:', error);
//     dispatch({ type: types.LOGIN.ERROR, payload: error.message });
//   }
// };

export const login = (username, password, navigate) => async dispatch => {
  dispatch({ type: types.LOGIN.START });
  try {
    const response = await instance.post(loginEndpoint, { username, password });
    if (response.data.mustChangePassword) {
      navigate('/go-beyond/new-password');
    } else {
      dispatch({ type: types.LOGIN.SUCCESS, payload: response.data });
      navigate('/fundingpage');
    }
  } catch (error) {
    console.error('Login failed:', error);
    dispatch({ type: types.LOGIN.ERROR, payload: error.message });
  }
};

export const initiateLoginFlow = params => dispatch => {
  dispatch({ type: types.LOGIN_START });
  //confirmLogin?
};

export const initiateGsisLogin = () => dispatch => {
  const protocol = 'http://';
  const host = process.env.REACT_APP_BACKEND_GSIS_HOST;
  const port = process.env.REACT_APP_FRONTEND_HOST_GSIS_PORT;
  const backendPath = process.env.REACT_APP_BACKEND_FLOWABLE_CONTEXT_PATH;
  const authClient = process.env.REACT_APP_AUTH2_CLIENT;

  const gsisAuthUrl = `${host}/oauth2/authorization/${authClient}`;

  console.log('Constructed GSIS Auth URL:', gsisAuthUrl);

  window.location.href = gsisAuthUrl;
};

// export const initiateGsisLogin = (gsisAuthUrl) => () => {
//   window.location.href = gsisAuthUrl;
// };

export const getOAuth2Clients = () => async dispatch => {
  dispatch({ type: types.GET_OAUTH2_CLIENTS.START });
  try {
    const response = await instance.get(getOAuth2ClientsEndpoint);
    console.log('OAuth2 Clients response:', response.data);
    dispatch({
      type: types.GET_OAUTH2_CLIENTS.SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    console.error('Failed to fetch OAuth2 clients:', error);
    dispatch({ type: types.GET_OAUTH2_CLIENTS.ERROR, payload: error.message });
  }
};

export const setNewPassword = newPassword => async dispatch => {
  dispatch({ type: types.SET_NEW_PASSWORD.START });
  try {
    const response = await instance.post(setNewPasswordEndpoint, {
      password: newPassword,
    });
    if (response.status < 200 && response.status > 299) {
      throw new Error(`Wrong status code ${response.status}`);
    }
    dispatch({ type: types.SET_NEW_PASSWORD.SUCCESS, payload: response.data });
    dispatch(clearForm(false));
  } catch (error) {
    console.error('Set new password failed:', error);
    dispatch({ type: types.SET_NEW_PASSWORD.ERROR, payload: error.message });
    throw error;
  }
};

export const requestTempPassword = email => async dispatch => {
  dispatch({ type: types.REQUEST_TEMP_PASSWORD.START });
  try {
    const response = await instance.post(askTempPasswordEndpoint, { email });
    dispatch({
      type: types.REQUEST_TEMP_PASSWORD.SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    console.error('Temp password request failed:', error);
    const errorMessage =
      error.response?.data?.message ||
      'An error occurred while requesting the temporary password';
    dispatch({
      type: types.REQUEST_TEMP_PASSWORD.ERROR,
      payload: errorMessage,
    });
  }
};

export const checkLoginStatus = () => async dispatch => {
  dispatch({ type: types.CHECK_LOGIN.START });
  try {
    const response = await instance.get(loginCheckerEndpoint);
    dispatch({ type: types.CHECK_LOGIN.SUCCESS, payload: response.data });
  } catch (error) {
    console.error('Login check failed:', error);
    dispatch({ type: types.CHECK_LOGIN.ERROR, payload: error.message });
  }
};

export const logoutUser = () => dispatch => {
  const url = '/app/logout';
  dispatch({ type: types.LOGOUT_USER.START });
  instance
    .get(url)
    .then(response => {
      dispatch({ type: types.LOGOUT_USER.SUCCESS, payload: response.data });
      dispatch(clearForm(false));
      // window.location.href = `${window.location.protocol}//${
      //   window.location.hostname
      // }${
      //   window.location.hostname === 'localhost'
      //     ? process.env.REACT_APP_FRONTEND_HOST_PORT
      //     : ''
      // }/go-beyond/login`;
    })
    .catch(error => {
      dispatch({ type: types.LOGOUT_USER.ERROR, payload: error.message });
      dispatch(clearForm(false));
    });
};

export const getUser = () => dispatch => {
  const url = '/app/rest/account-extended';
  dispatch({ type: types.GET_USER.START });
  instance
    .get(url)
    .then(response => {
      dispatch({ type: types.GET_USER.SUCCESS, payload: response.data });
    })
    .catch(error => {
      dispatch({ type: types.GET_USER.ERROR, payload: error.message });
    });
};

export const checkIsValidated = () => dispatch => {
  const url = '/onboarding/funding-application/check-validated';
  dispatch({ type: types.CHECK_VALIDATED.START });
  instance
    .get(url)
    .then(response => {
      dispatch({
        type: types.CHECK_VALIDATED.SUCCESS,
        payload: response.data?.validated ?? null,
      });
    })
    .catch(error => {
      dispatch({
        type: types.CHECK_VALIDATED.ERROR,
        payload: Errors.GenericRetrievalError,
      });
    });
};

export const getFundingAccount = () => dispatch => {
  const url = '/onboarding/funding-application/account';
  dispatch({ type: types.GET_FUNDING_ACCOUNT.START });
  instance
    .get(url)
    .then(response => {
      dispatch({
        type: types.GET_FUNDING_ACCOUNT.SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      dispatch({
        type: types.GET_FUNDING_ACCOUNT.ERROR,
        payload: error.message,
      });
    });
};

export const updateFundingAccount = updatedData => dispatch => {
  const url = '/onboarding/funding-application/account/edit';
  let payload = updatedData;
  payload = {
    firstName: payload.firstName,
    lastName: payload.lastName,
    profession: payload.profession,
    contactPhone: payload.contactPhone,
    contactEmail: payload.contactEmail,
    kad: payload.kad,
    secondaryKad: payload.secondaryKad,
    size: payload.size,
    companyPhone: payload.companyPhone,
    companyEmail: payload.companyEmail,
    companyWebsite: payload.companyWebsite,
  };

  dispatch({ type: types.UPDATE_FUNDING_ACCOUNT.START });
  instance
    .patch(url, payload)
    .then(response => {
      dispatch({
        type: types.UPDATE_FUNDING_ACCOUNT.SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      dispatch({
        type: types.UPDATE_FUNDING_ACCOUNT.ERROR,
        payload: error.message,
      });
    });
};

export const getCompanyLogo = () => dispatch => {
  const url = '/onboarding/funding-application/company-logo';
  dispatch({ type: types.GET_LOGO.START });
  instance
    .get(url, {
      responseType: 'blob',
    })
    .then(res => {
      const blob = res.data;
      console.log('Blob:', blob);
      dispatch({
        type: types.GET_LOGO.SUCCESS,
        payload: blob,
      });
    })
    .catch(err => {
      console.log({ errGetLogo: err });
      dispatch({
        type: types.GET_LOGO.ERROR,
        payload: err.message,
      });
    });
};

export const uploadCompanyLogo = formData => dispatch => {
  const url = '/onboarding/funding-application/company-logo';

  dispatch({ type: types.UPLOAD_LOGO.START });
  instance
    .put(url, formData)
    .then(res => {
      console.log({ resUpload: res.data });
      dispatch({
        type: types.UPLOAD_LOGO.SUCCESS,
        payload: res.data,
      });
    })
    .catch(err => {
      console.log({ errUpload: err });
      dispatch({
        type: types.UPLOAD_LOGO.ERROR,
        payload: err.response?.data?.message || err.message,
      });
    });
};

//DELETE company-logo

// export const deleteCompanyLogo = () => dispatch => {
//   const url = '/onboarding/funding-application/company-logo';

//   dispatch({ type: types.DELETE_LOGO.START });
//   instance
//     .delete(url)
//     .then(() => {
//       dispatch({
//         type: types.DELETE_LOGO.SUCCESS,
//       });
//     })
//     .catch(err => {
//       console.log(err);
//       dispatch({
//         type: types.DELETE_LOGO.ERROR,
//         payload: err.response?.data?.message || err.message,
//       });
//     });
// };

export const checkUser = navigate => dispatch => {
  const url = '/app/rest/account-checker';
  dispatch({ type: types.CHECK_USER.START });
  instance
    .get(url)
    .then(response => {
      dispatch({ type: types.CHECK_USER.SUCCESS, payload: response.data });
    })
    .catch(error => {
      dispatch({ type: types.CHECK_USER.ERROR, payload: error.message });
      dispatch(clearForm(true));
      dispatch(clearApptrack());
      dispatch(clearUser());
      navigate('/login');
      window.location.reload();
    });
};

export const checkUserLogged = (navigate, callback) => dispatch => {
  const url = '/app/rest/account-checker';
  dispatch({ type: types.CHECK_USER_LOGGED.START });
  instance
    .get(url)
    .then(response => {
      dispatch({
        type: types.CHECK_USER_LOGGED.SUCCESS,
        payload: response.data,
      });
      callback(true);
    })
    .catch(error => {
      dispatch({ type: types.CHECK_USER_LOGGED.ERROR, payload: error.message });
      dispatch(clearForm(true));
      dispatch(clearApptrack());
      dispatch(clearUser());
      callback(false);
    });
};

export const requestPasswordReset = (email, callback) => async dispatch => {
  dispatch({ type: types.REQUEST_PASSWORD_RESET.START });
  try {
    // API call to request password reset
    const response = await instance.post('/app/temp-password', { email });
    dispatch({ type: types.REQUEST_PASSWORD_RESET.SUCCESS });
    callback(false);
    return response.data;
  } catch (error) {
    dispatch({
      type: types.REQUEST_PASSWORD_RESET.ERROR,
      payload:
        error.response?.data?.message ||
        'An error occurred while resetting the password',
    });
    callback(true);
    throw error;
  }
};

export const setRememberMe = value => ({
  type: types.UPDATE_USER.SUCCESS,
  payload: { rememberMe: value },
});

export const clearUser = () => dispatch => {
  dispatch({ type: types.CLEAR_USER });
};

export const resetUser = () => ({
  type: types.RESET_USER,
});

export const changePassword =
  (newPassword, confirmPassword) => async dispatch => {
    dispatch({ type: types.CHANGE_PASSWORD.START });
    try {
      // API? na to brw
      // const response = await instance.post('/api/change-password', { newPassword, confirmPassword });
      dispatch({ type: types.CHANGE_PASSWORD.SUCCESS });
    } catch (error) {
      dispatch({
        type: types.CHANGE_PASSWORD.ERROR,
        payload: error.response?.data?.message || 'Failed to change password',
      });
    }
  };
